import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";


function FeatureSettings() {
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    enable_ugc: 1,
    enable_shortsandminis: 1,
    enable_donate: 1,
  });

  const base = process.env.REACT_APP_Baseurl;

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${base}/admin/Feature-Settings/index`, { headers });
      const data = res?.data?.data || {};
      setForm({
        enable_ugc: Number(data.enable_ugc ?? 1),
        enable_shortsandminis: Number(data.enable_shortsandminis ?? 1),
        enable_donate: Number(data.enable_donate ?? 1),
      });
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to load feature settings");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (access_token) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token]);

  const handleToggle = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
  };

  const handleSave = async () => {
    try {
      setShowOverlay(true);
      const payload = {
        enable_ugc: form.enable_ugc,
        enable_shortsandminis: form.enable_shortsandminis,
        enable_donate: form.enable_donate,
      };
      const res = await axios.patch(`${base}/admin/Feature-Settings/update`, payload, { headers });
      const ok = res?.data?.status;
      if (ok) {
        toast.success(res?.data?.message || "Feature settings updated");
      } else {
        toast.error(res?.data?.message || "Failed to update feature settings");
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to update feature settings");
    } finally {
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showOverlay && <Response_Processing />}
      <AdminSaveHeader heading="EPG Settings" saveText="Update Settings" saveMethod={handleSave} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Feature toggles" />

            <div className="d-flex align-items-center justify-content-between py-2">
              <MessageLabel text="Enable Livestream" />
              <AdminSwitch
                id="enable_ugc"
                name="enable_ugc"
                checked={Number(form.enable_ugc) === 1}
                onChange={handleToggle}
              />
            </div>

            <div className="d-flex align-items-center justify-content-between py-2">
              <MessageLabel text="Enable Playout" />
              <AdminSwitch
                id="enable_shortsandminis"
                name="enable_shortsandminis"
                checked={Number(form.enable_shortsandminis) === 1}
                onChange={handleToggle}
              />
            </div>
            <div className="d-flex align-items-center justify-content-between py-2">
              <MessageLabel text="Enable Radiostation" />
              <AdminSwitch
                id="enable_donate"
                name="enable_donate"
                checked={Number(form.enable_donate) === 1}
                onChange={handleToggle}
              />
            </div>
          </Wrapper>
        </LeftWrapper>
      </FormContainer>
    </>
  );
}

export default FeatureSettings;
